import { useState, useEffect } from 'react';


export default function useDeviceType() {
    const [deviceType, setDeviceType] = useState(window.innerWidth > 1024 ?
        'desktop' : (window.innerWidth >= 768 ? 'tablet' : 'mobile'));

    const updateDeviceType = () => {
        setDeviceType(window.innerWidth > 1024 ? 'desktop' : (window.innerWidth >= 768 ? 'tablet' : 'mobile'))
    }

    useEffect(() => {
        updateDeviceType();
        window.addEventListener('resize', updateDeviceType);
        return () => { window.removeEventListener('resize', updateDeviceType) }
    }, []);

    return deviceType;
}
